import { FC, ReactNode } from 'react';

import { Provider } from 'react-redux';

import store from 'src/store';

interface Props {
  children: ReactNode;
}

const AppProvider: FC<Props> = ({ children }) => <Provider store={store}>{children}</Provider>;

export default AppProvider;
